module.exports = __webpack_public_path__ + "static/profile-1-5cd6e2bcc136f80b3fabf96f1928c790.jpg";